import React from 'react'
import { Select } from 'antd'
import MyIcon from '../general/icon'

const MyEducationSelect = ({ 
  id,
  required = false,
  label = '',
  value = '',
  onChange,
  errorMsg,
  disabled = false,
  notFoundContent = '暂无数据',
  styles
}) => {
  let items = [
    {
      value: 1,
      label: '博士'
    },
    {
      value: 2,
      label: '硕士'
    },
    {
      value: 3,
      label: '本科'
    },
    {
      value: 4,
      label: '大专'
    },
    {
      value: 5,
      label: '高中'
    },
    {
      value: 6,
      label: '中专/技校'
    },
    {
      value: 7,
      label: '初中及以下'
    },
  ]

  const noData = (
    <div className='select-noData'>
      <span style={{ fontSize: '50px', color: '#aaa' }}><MyIcon name='kong' /></span>
      <p>{notFoundContent}</p>
    </div>
  )

  return (
    <div className='select-container'>
      <label>
        {label}
        {required && <span style={{ color: '#ae2a19' }}> *</span>}
      </label>

      <Select
        disabled={disabled}
        placeholder="选择一个学历要求"
        value={value}
        onChange={(value) => onChange(prevValues => ({ ...prevValues, [id]: value }))}
        notFoundContent={noData}
        options={items}
        style={{ width: '360px', height: '40px', marginBottom: '5px', ...styles }}
      />

      {errorMsg && (
        <div className="form-errormsg">
          <span><MyIcon name='jinggao' /></span> 
          <p>{errorMsg}</p>
        </div>
      )}
    </div>  
  )
}

export default MyEducationSelect
